import { render, staticRenderFns } from "./AzAuditLogButton.vue?vue&type=template&id=4d50236c&"
import script from "./AzAuditLogButton.vue?vue&type=script&lang=js&"
export * from "./AzAuditLogButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports